// Components
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import Dropdown from 'app/components/Dropdown';
import SearchableDropdown from 'app/components/SearchableDropdown';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import NewAttachment from 'app/components/NewAttachment';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import { commonMinDate } from 'app/utils/Parsers';
import useCreateBill from './useCreateBill';

const CreateBill = () => {
  const {
    mallList,
    storeList,
    handleMallChange,
    handleChangeStore,
    handleChange,
    values,
    error,
    handleCreateBill,
    pageLoading,
    uploadMediaHandler,
    navigate,
  } = useCreateBill();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={`Create Bill`}
          goTo={APP_CONSTANTS.BILL_VALIDATION}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mallId'}
              label='Mall name*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={values.mallId}
              handleChange={handleMallChange}
              errorText={error?.mallId}
            />
          </div>
          <div className='wd-50'>
            <SearchableDropdown
              id='storeId'
              label='Store name*'
              name='storeId'
              options={storeList}
              placeholder='Search store...'
              value={values.storeId}
              handleChange={handleChangeStore}
              errorText={error?.storeId}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Contact Number*'
              id='phone_number'
              placeholder='Contact Number'
              name='phone_number'
              value={values.phone_number}
              errorText={error?.phone_number}
              onChange={handleChange}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Invoice Date*'
              id='invoice_date'
              placeholder='DD-YY-MMMM'
              name='invoice_date'
              format='DD-MM-YYYY'
              type={'date'}
              // India today is both the earliest future date and the latest
              // past date, so commonMinDate() is used here as a maximum too.
              max={commonMinDate()}
              value={values?.invoice_date}
              onChange={handleChange}
              errorText={error?.invoice_date}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Shoppping Amount*'
              id='shopping_amount'
              placeholder='Shoppping Amount'
              name='shopping_amount'
              value={values.shopping_amount}
              errorText={error?.shopping_amount}
              onChange={handleChange}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Invoice Number*'
              id='invoice_number'
              type='text'
              placeholder='Invoice Number'
              name='invoice_number'
              value={values?.invoice_number}
              onChange={handleChange}
              errorText={error?.invoice_number}
            />
          </div>

          <div className='wd-50'>
            <label> Bill Image* </label>
            <NewAttachment
              // values.coverImage holds the S3/CloudFront URL — used both
              // for the in-form preview and persisted on form save.
              value={values?.coverImage}
              id='coverImage'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='coverImage'
              errorText={error?.coverImage}
            />
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateBill}
            variant='Save'
            name='Approve and Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateBill;
